import Methodology from './Methodology'

export default Methodology
